import { useCallback } from 'react';

const CAROUSEL_ITEMS = [
  {
    tag: '本周热播',
    title: '暑期档爆款合集',
    desc: '《封神第二部》《流浪地球3》领衔暑期最强片单，动作科幻喜剧一网打尽',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20movie%20collage%20with%20action%20heroes%20and%20sci-fi%20elements%2C%20cinematic%20dramatic%20lighting%20with%20warm%20golden%20and%20deep%20crimson%20accents%2C%20film%20poster%20style%20composition%20on%20dark%20background%2C%20theater%20atmosphere%20with%20spotlight%20effects%2C%20luxurious%20movie%20premiere%20aesthetic&width=600&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '高分推荐',
    title: '豆瓣9分神作精选',
    desc: '《大江大河3》《长相思2》口碑炸裂，年度必看高分影视剧盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20film%20award%20ceremony%20scene%20with%20golden%20trophies%20and%20red%20carpet%2C%20warm%20amber%20spotlight%20on%20dark%20stage%2C%20sophisticated%20cinema%20aesthetic%20with%20film%20reels%20and%20stars%2C%20prestigious%20movie%20atmosphere%20with%20velvet%20curtains&width=600&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '新片速递',
    title: '最新上线影片一览',
    desc: '每日更新最新上映大片，飘花电影网与555电影同步更新，先睹为快',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20movie%20premiere%20night%20scene%20with%20film%20projector%20beam%20cutting%20through%20darkness%2C%20new%20film%20reels%20and%20modern%20digital%20screening%2C%20cinematic%20light%20rays%20in%20warm%20gold%20tones%2C%20contemporary%20theater%20ambiance%20with%20excitement&width=600&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '8090怀旧影院',
    desc: '8090电影网经典老片专题，重温那些年感动过我们的港片与国产经典',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20cinema%20interior%20with%20classic%20film%20posters%20on%20walls%2C%20old%20movie%20projector%20with%20warm%20glow%2C%20retro%20Chinese%20cinema%20atmosphere%20with%20sepia%20tones%2C%20memory%20lane%20film%20aesthetic%20with%20faded%20photographs%20and%20ticket%20stubs&width=600&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    tag: '独家专题',
    title: '国产科幻崛起之路',
    desc: '从《流浪地球》到《封神》，深度解读中国电影工业的里程碑式突破',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20film%20set%20with%20advanced%20technology%20and%20traditional%20elements%20blended%2C%20dramatic%20lighting%20with%20cool%20silver%20and%20warm%20gold%20contrast%2C%20cinematic%20space%20and%20earth%20imagery%2C%20epic%20film%20production%20atmosphere&width=600&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    tag: '影评精选',
    title: '观众口碑风向标',
    desc: '聚合各大平台真实影评，帮你甄别哪些影片值得花时间观看',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20critic%20workspace%20with%20movie%20screens%20and%20review%20notes%2C%20cinematic%20lighting%20casting%20dramatic%20shadows%2C%20intellectual%20film%20analysis%20atmosphere%20with%20screenings%20and%20discussions%2C%20warm%20amber%20reading%20light%20in%20dark%20study%20with%20film%20memorabilia&width=600&height=400&seq=carousel-06&orientation=landscape',
  },
];

export default function SectionCarousel() {
  const handleImgError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.setAttribute('data-failed', 'true');
  }, []);

  return (
    <section id="carousel" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-500/15">
            <i className="ri-layout-masonry-line text-secondary-400 text-lg"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              焦点专题
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
              精选影视专题内容，发现更多好片
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.tag}
              className="group rounded-xl overflow-hidden bg-background-200/60 border border-background-300/40 hover:border-background-300/70 transition-all cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={handleImgError}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-background-50/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-semibold bg-accent-500/80 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}